import { ActionDisabledCondition, BatchUserAction, BulkUserAction, UserAction } from '@mediahaven/shared';
import { ApiFragment, RecordType, User } from '@stylehaven/components';

/* CSV export
 * Available when:
 *  * User has export profiles
 *  * User has export rights
 *  * It is not a representation
 *  * It is not deleted
 * Disabled when:
 *   * Never
 */
export function GetCsvExportUserAction(record: ApiFragment, exportProfileCount: number): UserAction {
    const hasExportProfiles: boolean = exportProfileCount > 0;
    const hasExportRights: boolean = record.hasExportRights();
    const isRepresentation: boolean = record.getRecordType() === RecordType.Representation;

    const isDeleted: boolean = record.isDeleted();

    const availableConditions: boolean[] = [hasExportProfiles, hasExportRights, !isDeleted, !isRepresentation];
    const disableConditions: ActionDisabledCondition[] = [];

    const exportAction: UserAction = new UserAction(availableConditions, disableConditions);
    return exportAction;
}

export function GetBulkCsvExportUserAction(
    records: readonly ApiFragment[],
    exportProfileCount: number
): BulkUserAction {
    const availableConditions: boolean[] = [];
    const disableConditions: ActionDisabledCondition[] = [];

    return new BulkUserAction(
        records,
        availableConditions,
        disableConditions,
        GetCsvExportUserAction,
        false,
        exportProfileCount
    );
}

/* Batch Couple to parent
 *  Disabled when:
 *   * Never
 */
export function GetBatchCsvExportUserAction(
    totalResults: number | undefined,
    exportProfileCount: number,
    user: User
): BatchUserAction {
    // MED-6070: Total exports at once is limited
    const MAX_EXPORTS: number = 100000;
    const exceedsLimit: boolean = !totalResults || totalResults > MAX_EXPORTS;

    const hasExportProfiles: boolean = exportProfileCount > 0;
    const hasExportRights: boolean = user.Rights.ExportRights;

    const availableConditions: boolean[] = [hasExportProfiles, hasExportRights];
    const disableConditions: ActionDisabledCondition[] = [
        {
            condition: exceedsLimit,
            tooltip: 'batch.limit-exceeded',
            tooltipOptions: {
                limit: MAX_EXPORTS
            }
        }
    ];

    return new BatchUserAction(availableConditions, disableConditions);
}
